import type { GetContextMenuItemsParams, GridApi, MenuItemDef } from 'ag-grid-community';
import { useCallback } from 'react';

import type { Category } from '../../../../../shared/middlewares/analytics/logger';
import { logAnalytics } from '../../../../../shared/middlewares/analytics/logger';

export function useContextMenuItems(blotterCategory: Category, gridApi: GridApi | undefined) {
  return useCallback(
    ({ defaultItems }: GetContextMenuItemsParams) => {
      const generateExportMenuWithAnalytics = (): MenuItemDef => {
        return {
          name: 'Export',
          subMenu: [
            {
              name: 'CSV Export',
              action: () => {
                gridApi?.exportDataAsCsv({});
                logAnalytics.trackEvent(blotterCategory, 'Export CSV');
              },
              icon: "<span class='ag-icon ag-icon-csv'/>",
            },
            {
              name: 'Excel Export',
              action: () => {
                gridApi?.exportDataAsExcel({});
                logAnalytics.trackEvent(blotterCategory, 'Export Excel');
              },
              icon: "<span class='ag-icon ag-icon-excel'/>",
            },
          ],
          icon: "<span class='ag-icon ag-icon-save'/>",
        };
      };

      return [...(defaultItems ?? []).filter(x => x !== 'export'), generateExportMenuWithAnalytics()];
    },
    [gridApi, blotterCategory],
  );
}
